import { createSelector } from "reselect";
import { map, head, path } from "ramda";

import {
  nationalitiesSelector,
  countriesSelector,
  watchListsSelector,
} from "../../../selectors";

export const watchListEntriesSelector = path(["watchListEntries", "entries"]);

export const watchListEntriesLoadingSelector = path([
  "watchListEntries",
  "isLoading",
]);

export const watchListEntrySelector = path([
  "watchListEntries",
  "watchListEntry",
]);

export const watchListEntriesFiltersSelector = path([
  "watchListEntries",
  "filters",
]);

export const watchListEntriesPageInfoSelector = path([
  "watchListEntries",
  "pageInfo",
]);

export const noEntriesMessageWatchListSelector = path([
  "watchListEntries",
  "noEntriesMessage",
]);

export const watchListMultipleSearchEntriesSelector = path(["watchListMultipleSearchEntries", "entries"]);

export const watchListMultipleSearchEntriesLoadingSelector = path([
  "watchListMultipleSearchEntries",
  "isLoading",
]);

export const watchListMultipleSearchEntrySelector = path([
  "watchListMultipleSearchEntries",
  "watchListEntry",
]);

export const watchListMultipleSearchEntriesFiltersSelector = path([
  "watchListMultipleSearchEntries",
  "filters",
]);

export const watchListMultipleSearchEntriesPageInfoSelector = path([
  "watchListMultipleSearchEntries",
  "pageInfo",
]);

export const noEntriesMessageWatchListMultipleSearchSelector = path([
  "watchListMultipleSearchEntries",
  "noEntriesMessage",
]);

export const watchListEntriesByWatchListSelector = path([
  "watchListEntriesByWatchList",
  "entries",
]);

export const watchListEntriesByWatchListFiltersSelector = path([
  "watchListEntriesByWatchList",
  "filters",
]);

export const watchListEntriesByWatchListPageInfoSelector = path([
  "watchListEntriesByWatchList",
  "pageInfo",
]);

export const watchListEntriesByWatchListIsLoadingSelector = path([
  "watchListEntriesByWatchList",
  "isLoading",
]);

export const watchListEntriestExportCsv = path([
  "watchListEntriesByWatchList",
  "data",
]);

export const watchListEntriesExportIsLoadingSelector = path([
  "watchListEntriesByWatchList",
  "isExportLoading",
]);

export const watchListAllEntriesExportIsLoadingSelector = path([
  "watchListEntriesByWatchList",
  "isExportAllLoading",
]);

export const watchListDeactivateIsLoadingSelector = path([
  "watchListEntriesByWatchList",
  "deactivateLoading",
]);

export const uploadCsvCustomWatchlistIsLoadingSelector = path([
  "uploadCsvCustomWatchlist",
  "isLoading",
]);

export const updateWatchListEntrySelector = createSelector(
  watchListEntrySelector,
  head
);

export const nationalitiesOptionsSelector = createSelector(
  nationalitiesSelector,
  map((n) => ({ value: n.id, label: n.name }))
);

export const countriesOptionsSelector = createSelector(
  countriesSelector,
  map((n) => ({
    value: n.id,
    label: n.name + (n.description !== null ? n.description : ""),
  }))
);

export const watchListsOptionsSelector = createSelector(
  watchListsSelector,
  map((n) => ({ value: n.id, label: n.name, ...n }))
);

export const getFiltersWatchListEntriesByWatchList = path([
  "watchListEntriesByWatchList",
  "filters",
]);

export const selectCreateWatchListEntryLoading = path([
  "createWatchListEntry",
  "isLoading",
]);

export const selectUpdateWatchListEntryLoading = path([
  "updateWatchListEntry",
  "isLoading",
]);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/selectors/index.js